// Import action types related to posts
import {
  POSTMORE_FETCH_DATA_SUCCESS,
  POSTMORE_HAVE_ERROR,
  POSTMORE_ARE_LOADING,
} from "../actionType";

// Define the initial state for the Post reducer
const initialState = {
  data: [], // Initialize data as an empty array
  loading: false, // Set loading to false initially
  error: [], // Initialize error as an empty array
};

// Reducer function to handle post-related actions and update state accordingly
export function PostMoreReducer(state = initialState, action) {
  switch (action.type) {
    // Handle error case when fetching posts
    case POSTMORE_HAVE_ERROR:
      return {
        ...state,
        error: action.hasError, // Update the error state with the error from the action
        loading: false, // Set loading to false since the request is complete
      };

    // Handle loading state when posts are being fetched
    case POSTMORE_ARE_LOADING:
      return {
        ...state,
        loading: action.isLoading, // Update the loading state with the loading status from the action
      };

    // Handle success case when posts are successfully fetched
    // Handle success case when posts are successfully fetched
    case POSTMORE_FETCH_DATA_SUCCESS:
      const { data: rawData, page } = action.Post;

      return {
        ...state,
        data: rawData, // Store the full response object logic handled in component
        loading: false, // Set loading to false since the request is complete
        error: [], // Clear any previous errors (assuming the success case means no error)
      };

    // Return the current state by default if action type is not recognized
    default:
      return state;
  }
}
